import { useContext } from "react";

import { Grid, Grow } from "@material-ui/core";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import SelectErp from "../../../../components/basics/SelectErp";

import { Body, Importacao, Padding } from "../styles/Emissao";

import { EmissaoContext } from "../contexts/EmissaoContext";

const TabEmissaoDI = ({ ...props }) => {
  const {
    diImpWayOf,
    setDiImpWayOf,
    diDeclarationDate,
    setDiDeclarationDate,
    diDeclarationDiNumber,
    setDiDeclarationDiNumber,
    diDeclarationUf,
    setDiDeclarationUf,
    diDeclarationCity,
    setDiDeclarationCity,
    diDeclarationDateDes,
    setDiDeclarationDateDes,
    diDeclarationDrawback,
    setDiDeclarationDrawback,
    diIntermediaryType,
    setDiIntermediaryType,
    listViaTransporte,
    diIntermediaryTypeList,
    listUf,
    diAcquirerUf,
    setAcquirerUf,
    diAcquirerDocument,
    setAcquirerDocument,
    visualizationOnly,
  } = useContext(EmissaoContext);

  return (
    <Importacao>
      <Grid container spacing={2}>
        <Grow in={true}>
          <Grid item lg={6} sm={12}>
            <Body>
              <Card
                label="INF. DESEMBARAÇO ADUANEIRO"
                line="left"
                lineColor="primary"
              >
                <Padding padding="20">
                  <Grid container spacing={2}>
                    <Grid item lg={6} sm={12}>
                      <TextField
                        value={diDeclarationDiNumber}
                        setValue={setDiDeclarationDiNumber}
                        label="N° DI"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={6} sm={12}>
                      <TextField
                        value={diDeclarationDate}
                        type="date"
                        setValue={setDiDeclarationDate}
                        label="Data do Registro"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={6} sm={12}>
                      <SelectErp
                        label="UF Desembaraço"
                        value={diDeclarationUf}
                        setValue={setDiDeclarationUf}
                        optionsList={listUf}
                        descriptionField="estado"
                        size="small"
                        InputLabelProps={{
                          shrink: true,
                        }}
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={6} sm={12}>
                      <TextField
                        value={diDeclarationCity}
                        setValue={setDiDeclarationCity}
                        label="Local Desembaraço"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={6} sm={12}>
                      <TextField
                        type="date"
                        value={diDeclarationDateDes}
                        setValue={setDiDeclarationDateDes}
                        label="Data do Desembaraço"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={6} sm={12}>
                      <TextField
                        value={diDeclarationDrawback}
                        setValue={setDiDeclarationDrawback}
                        label="Nº Drawback"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                  </Grid>
                </Padding>
              </Card>
            </Body>
          </Grid>
        </Grow>
        <Grow in={true} {...(true ? { timeout: 800 } : {})}>
          <Grid item lg={6} sm={12}>
            <Card label="IMPORTAÇÃO" line="left" lineColor="primary">
              <Padding padding="20">
                <Grid container spacing={2}>
                  <Grid item lg={12} sm={12}>
                    <SelectErp
                      value={diImpWayOf}
                      setValue={setDiImpWayOf}
                      optionsList={listViaTransporte}
                      descriptionField="label"
                      label="Via de Transporte"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={visualizationOnly}
                    />
                  </Grid>

                  <Grid item lg={12} sm={12}>
                    <SelectErp
                      value={diIntermediaryType}
                      setValue={setDiIntermediaryType}
                      optionsList={diIntermediaryTypeList}
                      descriptionField="label"
                      label="Tipo de intermédio"
                      size="small"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      disabled={visualizationOnly}
                    />
                  </Grid>

                  {diIntermediaryType?.value > 1 && (
                    <>
                      <Grid item lg={6} sm={12}>
                        <SelectErp
                          label="UF adquirente/encomendante"
                          value={diAcquirerUf}
                          setValue={setAcquirerUf}
                          optionsList={listUf}
                          descriptionField="estado"
                          size="small"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          disabled={visualizationOnly}
                        />
                      </Grid>
                      <Grid item lg={6} sm={12}>
                        <TextField
                          value={diAcquirerDocument}
                          setValue={setAcquirerDocument}
                          label="CNPJ adquirente/encomendante"
                          size="small"
                          maxLength={14}
                          disabled={visualizationOnly}
                        />
                      </Grid>
                    </>
                  )}
                </Grid>
              </Padding>
            </Card>
          </Grid>
        </Grow>
      </Grid>
    </Importacao>
  );
};

export default TabEmissaoDI;
